import useMyInfo from '@api/hooks/auth/useMyInfo';
import {
  hasActiveIconicSubscriptionToGoal,
  hasActiveLiteSubscriptionToGoal,
  hasActiveSubscriptionToGoal
} from '@models/Me';
import useTestSeriesInfo from './useTestSeriesInfo';

const useGoalSubscription = () => {
  const { data } = useTestSeriesInfo();

  const { goal, isSpecial } = data;
  const { uid } = goal ?? {};

  const { myInfo } = useMyInfo();
  const isIconicUser = hasActiveIconicSubscriptionToGoal(myInfo ?? {}, uid);
  const isPlusUser = hasActiveSubscriptionToGoal(myInfo ?? {}, uid);
  const isLiteUser = hasActiveLiteSubscriptionToGoal(myInfo ?? {}, uid);

  const isSubscribed = isIconicUser || isPlusUser || isLiteUser;

  return {
    isSubscribed,
    isSpecial
  };
};

export default useGoalSubscription;
